import { useQuery } from '@tanstack/react-query';
import { getCatalogByDepartmentSectionIds } from '../apis/search-catalog';

interface UseCatalogByDepartmentSectionsByIdParams {
  sectionId: string;
  limit: number;
  offset: number;
}

export const useCatalogByDepartmentSectionsByIdQuery = ({
  sectionId,
  limit,
  offset,
}: UseCatalogByDepartmentSectionsByIdParams) => {
  return useQuery({
    queryKey: ['department-section', sectionId, limit, offset],
    queryFn: async () => {
      const sectionServices = await getCatalogByDepartmentSectionIds(
        [sectionId],
        limit,
        offset
      );
      return sectionServices;
    },
    enabled: !!sectionId,
    staleTime: 1000 * 60 * 5,
    retry: 3,
    retryDelay: 1000,
  });
};
